import Model from './Model'

export default class Statistic extends Model
{
    static async get (type, from, to, detailed = false) {
        const params = { detailed, type, from, to }
        const { data } = await Http.get(route('api.v1.reports.statistics'), { params })
        return this.make(data)
    }

    static async getDetailed (type, from, to) {
        return this.get(type, from, to, true)
    }
}
